import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from "../../../environments/environment.prod";
import {Financiamento} from "../../../model/Financiamento";

@Injectable()
export class PayrollProvider {

  apiBase: string = "/bookkeeping/v1/payroll-search";

  constructor(public http: HttpClient, public oauthService: OAuthService) {
  }

  getByCompanyId(companyId, cpf, period) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}/${companyId}/${cpf}/${period.year}/${period.month}`, {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: any[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  runEsPayrollSearch(obj) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiLogin}${this.apiBase}/request-update/${localStorage.getItem('idEmpresa')}`, obj, {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: any[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }


}
